export default "__VITE_ASSET__CG7in$YC__"